<div class="container mt-5">
  <div class="row justify-content-left">
    <div
      class="col-md-6 col-sm-12 mb-4"
      *ngFor="let rental of rentals$ | async"
    >
      <div class="card shadow-lg h-100 rental-card" (click)="viewDetails(rental.id)" style="cursor:pointer;">
        <!-- Main image -->
        <img
          [src]="rental.images?.[0]"
          class="card-img-top"
          alt="{{ rental.title }}"
          style="height: 350px; object-fit: cover;"
        />

        <!-- Rental info -->
        <div class="card-body">
          <h3 class="card-title">${{ rental.price }} / month</h3>
          <ul class="list-inline mt-2">
            <li class="list-inline-item"><strong>{{ rental.bedrooms }} Beds</strong></li>
            <li class="list-inline-item"><strong>{{ rental.bathrooms }} Baths</strong></li>
            <li class="list-inline-item"><strong>{{ rental.sqft }} sqft</strong></li>
          </ul>
          <p class="card-text text-muted">{{ rental.address }}</p>
          <div
        class="card-text"
        [innerHTML]="rental.description">
      </div>
<button
    class="btn btn-dark fw-bold"
  >
    <span >Details</span>
  </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="(rentals$ | async)?.length === 0" class="text-center mt-5">
    <p class="text-muted">No rentals available at this time.</p>
  </div>
</div>
